module.exports = __webpack_public_path__ + "media/images/prizes__second-425cb9b3536073b256ae1df601cbe8ce.jpg";